module.exports = __webpack_public_path__ + "img/1.ff5ee8a4.jpg";